import React from 'react';
import {Link} from "react-router-dom";

const Nav = () => {
    return (
        <ul className="mainmenu">
            <li className="has-droupdown"><Link to="">Home</Link></li>
            <li><Link to="/about-us">About</Link></li>
            <li className="has-droupdown"><Link to="/features-product">Features Product</Link>
               <ul className="submenu">
                <li><Link to="/ai-comment-autoreply">Ai Comments Autoreply</Link></li>
                <li><Link to="/multimodal-ai-agent">Multimodal Ai Agent</Link></li>
                <li><Link to="/erp-solutions">ERP Solutions</Link></li>
                  </ul>
            </li>    
            <li className="has-droupdown"><Link to="/services">Services</Link>
                <ul className="submenu">
                    <li><Link to="/app-development">App Development</Link></li>
                    <li><Link to="/web-design-and-development">Web Design and Development</Link></li>
                    <li><Link to="/web-application">Web Application</Link></li>
                    <li><Link to="/ecommerce-solution">eCommerce Solution</Link></li>
                    <li><Link to="/crm-solutions">CRM Solutions</Link></li>
                    <li><Link to="/email-marketing">Email Marketing</Link></li>
                    <li><Link to="/video-editing">Video Editing</Link></li>
                    <li><Link to="/hosting">Web Hosting</Link></li>
                    <li><Link to="/seo">SEO</Link></li>
                    <li><Link to="/facebook-promotion-and-boosting">Facebook Boosting</Link></li>
                    <li><Link to="/youtube-advertisement">YouTube Advertisement</Link></li>
                    <li><Link to="/google-advertisement">Google Advertisement</Link></li>
                </ul>
            </li>
            <li className=""><Link to="/blogs">Blog</Link></li>
            <li><Link to="portfolio">Portfolio</Link></li>
            {/* <li className="has-droupdown"><Link to="">Portfolio</Link>
                <ul className="submenu">
                    <li><Link to="/portfolio">IT Portfolio</Link></li>
                    <li><Link to="/digital-portfolio">Digital Portfolio</Link></li>
                    <li><Link to="/design-portfolio">Design Portfolio</Link></li>
                </ul>
            </li> */}
            <li className="#"><Link to="/contact">Contact</Link></li>
        </ul>
    )
}
export default Nav;
